import { capitalize } from 'lodash';

import { Text } from '@/components/text';
import { Tooltip } from '@/components/tooltip';
import { VisuallyHidden } from '@/components/visually-hidden';
import { DAYS_OF_WEEK } from '@/lib/constants';
import { tv } from '@/utils/styles';

interface Props {
  operatingDays: string[];
  label?: string;
}

const DayOfWeekCalendar = ({ operatingDays, label }: Props) => {
  const { base, item, itemLabel } = styles();

  return (
    <div className={base()}>
      {label && <Text className="mb-0">{label}:</Text>}
      <ol className={base()}>
        {DAYS_OF_WEEK.map((day) => {
          const isActive = operatingDays.includes(day);
          const userString = isActive ? `Departs ${capitalize(day)}` : `${capitalize(day)} - No service`;

          return (
            <li key={day} className={item({ isActive })}>
              <Tooltip content={userString}>
                <span className={itemLabel({ isActive })}>{day}</span>
                <VisuallyHidden>{userString}</VisuallyHidden>
              </Tooltip>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex gap-2',
    item: 'min-w-6 rounded bg-grey-100 px-0.5 text-center text-grey-400',
    itemLabel: 'text-xs capitalize line-through',
  },
  variants: {
    isActive: {
      true: {
        item: 'bg-grey-200 text-text-primary',
        itemLabel: 'no-underline',
      },
    },
  },
});

export { DayOfWeekCalendar };
